import * as actionTypes from './actionTypes';
import * as actions from './index';


export const getArticleTreeStart = () => {
    return {
        type: actionTypes.GET_ARTICLE_TREE_START
    };
};

export const getArticleTreeSuccess = (children) => {
    return {
        type: actionTypes.GET_ARTICLE_TREE_SUCCESS,
        children: children
    };
};

export const getArticleTreeFail = (error) => {
    return {
        type: actionTypes.GET_ARTICLE_TREE_FAIL,
        error: error
    };
};


export const getArticleTree = () => {
    return dispatch => {
        dispatch(getArticleTreeStart());
        window.flow.distprojectGetFullTree('pmdb_newstv', 0).then(res => {
            dispatch(getArticleTreeSuccess(res.children));
        }).catch(res => {
            console.log(res);
            dispatch(getArticleTreeFail(res.message));
            dispatch(actions.applicationError(res.message));
        });
    };
};

const getArticleByDistStart = () => {
    return {
        type: actionTypes.GET_ARTICLE_BY_DIST_START
    };
};

const getArticleByDistSuccess = (articles) => {
    return {
        type: actionTypes.GET_ARTICLE_BY_DIST_SUCCESS,
        articles: articles
    };
};



export const getArticleByDist = () => {
    return dispatch => {
        dispatch(getArticleByDistStart());
        /* TODO: VARIABLES FOR DISTRIBUTION TREE */
        window.flow.getDistprojectsForDist('pmdb_newstv', 0, [], { limit: 25 })
            .then(res => {
                getArticleByDistSuccess(res.distproject.elements);
                dispatch(actions.getArticles());
            }).catch(err => {
                dispatch(getArticleByDistFail(err.message));
                dispatch(actions.applicationError(err.message));
            });
    };
};

const getArticleByDistFail = (error) => {
    return {
        type: actionTypes.GET_ARTICLE_BY_DIST_FAIL,
        error: error
    };
};